<div class="container">
  <div class="member-state">
    <button class="btn add-user-btn" mat-raised-button color="primary" (click)="createMember()">
      Add User
    </button>
  </div>

  <div class="active-toggle-field">
    <mat-button-toggle-group name="memberStatus" [value]="activeMemberFilter">
      <mat-button-toggle [value]="true" (click)="showMembers(true)">Active</mat-button-toggle>
      <mat-button-toggle [value]="false" (click)="showMembers(false)">Archived</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="memberId">
      <th mat-header-cell *matHeaderCellDef>memberId</th>
      <td mat-cell *matCellDef="let member">{{ member.memberId }}</td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef>firstName</th>
      <td mat-cell *matCellDef="let member">{{ member.firstName }}</td>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef>lastName</th>
      <td mat-cell *matCellDef="let member">{{ member.lastName }}</td>
    </ng-container>

    <ng-container matColumnDef="loginEmail">
      <th mat-header-cell *matHeaderCellDef>loginEmail</th>
      <td mat-cell *matCellDef="let member">{{ member.loginEmail }}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell scope="col" *matHeaderCellDef>Edit</th>
      <td mat-cell *matCellDef="let member">
        <button mat-icon-button (click)="editMember(member)">
          <svg width="21px" height="21px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
            <g id="Member" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g
                id="Member---Job"
                transform="translate(-1349.000000, -232.000000)"
                fill="#2F9BBF"
                fill-rule="nonzero"
              >
                <g id="Group-31" transform="translate(1349.000000, 177.000000)">
                  <g id="Group-30" transform="translate(0.000000, 55.000000)">
                    <g id="0020-pencil5">
                      <path
                        d="M20.05815,0.9408 C19.46805,0.3507 18.6837,0.02625 17.85,0.02625 C17.0163,0.02625 16.2309,0.3507 15.64185,0.9408 L5.40435,11.1783 C5.34975,11.2329 5.3088,11.298 5.28255,11.37045 L3.18255,17.14545 C3.11325,17.3376 3.1605,17.5518 3.30435,17.69565 C3.4041,17.79645 3.5385,17.85 3.67605,17.85 C3.7359,17.85 3.7968,17.8395 3.8556,17.8185 L9.6306,15.7185 C9.70305,15.69225 9.76815,15.65025 9.82275,15.5967 L20.06025,5.3592 C20.65035,4.7691 20.9748,3.98475 20.9748,3.15 C20.9748,2.31525 20.65035,1.5309 20.06025,0.9408 L20.05815,0.9408 Z M9.16125,14.7714 L4.5528,16.4472 L6.2286,11.83875 L14.7,3.36735 L17.63265,6.3 L9.16125,14.7714 Z M19.31685,4.6158 L18.375,5.5566 L15.44235,2.62395 L16.3842,1.68315 C16.77585,1.2915 17.29665,1.07625 17.85,1.07625 C18.40335,1.07625 18.92415,1.2915 19.31685,1.68315 C19.7085,2.0748 19.92375,2.5956 19.92375,3.14895 C19.92375,3.7023 19.7085,4.2231 19.31685,4.61475 L19.31685,4.6158 Z"
                        id="Shape"
                      ></path>
                      <path
                        d="M18.375,21 L1.575,21 C0.70665,21 0,20.29335 0,19.425 L0,2.625 C0,1.75665 0.70665,1.05 1.575,1.05 L12.075,1.05 C12.3648,1.05 12.6,1.2852 12.6,1.575 C12.6,1.8648 12.3648,2.1 12.075,2.1 L1.575,2.1 C1.2852,2.1 1.05,2.3352 1.05,2.625 L1.05,19.425 C1.05,19.7148 1.2852,19.95 1.575,19.95 L18.375,19.95 C18.6648,19.95 18.9,19.7148 18.9,19.425 L18.9,8.925 C18.9,8.6352 19.1352,8.4 19.425,8.4 C19.7148,8.4 19.95,8.6352 19.95,8.925 L19.95,19.425 C19.95,20.29335 19.24335,21 18.375,21 Z"
                        id="Shape"
                      ></path>
                    </g>
                    <g id="0020-pencil5">
                      <path
                        d="M20.05815,0.9408 C19.46805,0.3507 18.6837,0.02625 17.85,0.02625 C17.0163,0.02625 16.2309,0.3507 15.64185,0.9408 L5.40435,11.1783 C5.34975,11.2329 5.3088,11.298 5.28255,11.37045 L3.18255,17.14545 C3.11325,17.3376 3.1605,17.5518 3.30435,17.69565 C3.4041,17.79645 3.5385,17.85 3.67605,17.85 C3.7359,17.85 3.7968,17.8395 3.8556,17.8185 L9.6306,15.7185 C9.70305,15.69225 9.76815,15.65025 9.82275,15.5967 L20.06025,5.3592 C20.65035,4.7691 20.9748,3.98475 20.9748,3.15 C20.9748,2.31525 20.65035,1.5309 20.06025,0.9408 L20.05815,0.9408 Z M9.16125,14.7714 L4.5528,16.4472 L6.2286,11.83875 L14.7,3.36735 L17.63265,6.3 L9.16125,14.7714 Z M19.31685,4.6158 L18.375,5.5566 L15.44235,2.62395 L16.3842,1.68315 C16.77585,1.2915 17.29665,1.07625 17.85,1.07625 C18.40335,1.07625 18.92415,1.2915 19.31685,1.68315 C19.7085,2.0748 19.92375,2.5956 19.92375,3.14895 C19.92375,3.7023 19.7085,4.2231 19.31685,4.61475 L19.31685,4.6158 Z"
                        id="Shape"
                      ></path>
                      <path
                        d="M18.375,21 L1.575,21 C0.70665,21 0,20.29335 0,19.425 L0,2.625 C0,1.75665 0.70665,1.05 1.575,1.05 L12.075,1.05 C12.3648,1.05 12.6,1.2852 12.6,1.575 C12.6,1.8648 12.3648,2.1 12.075,2.1 L1.575,2.1 C1.2852,2.1 1.05,2.3352 1.05,2.625 L1.05,19.425 C1.05,19.7148 1.2852,19.95 1.575,19.95 L18.375,19.95 C18.6648,19.95 18.9,19.7148 18.9,19.425 L18.9,8.925 C18.9,8.6352 19.1352,8.4 19.425,8.4 C19.7148,8.4 19.95,8.6352 19.95,8.925 L19.95,19.425 C19.95,20.29335 19.24335,21 18.375,21 Z"
                        id="Shape"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell scope="col" *matHeaderCellDef>Active</th>
      <td mat-cell *matCellDef="let member">
        <mat-slide-toggle
          [checked]="!member.disabled"
          (change)="onStateChange($event, member)"
        ></mat-slide-toggle>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-progress-bar *ngIf="isLoading" class="progress-bar" color="primary" mode="query">
  </mat-progress-bar>
  <mat-paginator
    [length]="paginatorControl.length"
    [pageSize]="paginatorControl.pageSize"
    [pageSizeOptions]="paginatorControl.pageSizeOptions"
    [pageIndex]="paginatorControl.pageIndex"
    (page)="paginate($event)"
    #paginator
  >
  </mat-paginator>
</div>
